module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/pubkeyhash/index.js
// module id = 115
// module chunks = 0